var map = {
	"./00-marvel.webp": "./src/assets/images/origins/marvel/00-marvel.webp",
	"./01-captain-america-first-avenger.webp": "./src/assets/images/origins/marvel/01-captain-america-first-avenger.webp",
	"./02-captain-marvel.webp": "./src/assets/images/origins/marvel/02-captain-marvel.webp",
	"./03-iron-man-1.webp": "./src/assets/images/origins/marvel/03-iron-man-1.webp",
	"./04-iron-man-2.webp": "./src/assets/images/origins/marvel/04-iron-man-2.webp",
	"./05-the-incredible-hulk.webp": "./src/assets/images/origins/marvel/05-the-incredible-hulk.webp",
	"./06-thor.webp": "./src/assets/images/origins/marvel/06-thor.webp",
	"./07-the-avengers.webp": "./src/assets/images/origins/marvel/07-the-avengers.webp",
	"./08-iron-man-3.webp": "./src/assets/images/origins/marvel/08-iron-man-3.webp",
	"./09-thor-the-dark-world.webp": "./src/assets/images/origins/marvel/09-thor-the-dark-world.webp",
	"./10-captain-america-the-winter-soldier.webp": "./src/assets/images/origins/marvel/10-captain-america-the-winter-soldier.webp",
	"./11-guardians-of-the-galaxy-vol-1.webp": "./src/assets/images/origins/marvel/11-guardians-of-the-galaxy-vol-1.webp",
	"./12-guardians-of-the-galaxy-vol- 2.webp": "./src/assets/images/origins/marvel/12-guardians-of-the-galaxy-vol- 2.webp",
	"./13-avengers-age-of-ultron.webp": "./src/assets/images/origins/marvel/13-avengers-age-of-ultron.webp",
	"./14-ant-man.webp": "./src/assets/images/origins/marvel/14-ant-man.webp",
	"./15-captain-america-civil-war.webp": "./src/assets/images/origins/marvel/15-captain-america-civil-war.webp",
	"./16-spider-man-homecoming.webp": "./src/assets/images/origins/marvel/16-spider-man-homecoming.webp",
	"./17-doctor-strange.webp": "./src/assets/images/origins/marvel/17-doctor-strange.webp",
	"./18-black-panther.webp": "./src/assets/images/origins/marvel/18-black-panther.webp",
	"./19-thor-ragnarok.webp": "./src/assets/images/origins/marvel/19-thor-ragnarok.webp",
	"./20-avengers-infinity-war.webp": "./src/assets/images/origins/marvel/20-avengers-infinity-war.webp",
	"./21-ant-man-and-the-wasp.webp": "./src/assets/images/origins/marvel/21-ant-man-and-the-wasp.webp",
	"./22-avengers-endgame.webp": "./src/assets/images/origins/marvel/22-avengers-endgame.webp",
	"./23-captain-america-the-return-of-the-first-avenger.webp": "./src/assets/images/origins/marvel/23-captain-america-the-return-of-the-first-avenger.webp",
	"./26-les-eternels.webp": "./src/assets/images/origins/marvel/26-les-eternels.webp"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images/origins/marvel sync ^\\.\\/.*$";